/*
  Pointer-tracked tilt + foil sheen for the product stage — "like tilting a
  holo into the light". Ported from
  design-concepts/06-holofoil/product.html lines ~291-316.

  Scoped to [data-holo-tilt] (there is normally one per product page, but
  this supports more defensively). Guarded by (pointer: fine) and
  prefers-reduced-motion, like the concept script. rAF-throttled per
  instance. Re-initializes on shopify:section:load (theme editor) with a
  double-bind guard so re-rendered sections don't stack listeners.
*/
(function () {
  function initTilt(stage) {
    if (stage.dataset.holoTiltBound === 'true') return;

    var frame = stage.querySelector('.pd-frame');
    if (!frame) return;

    var fine = window.matchMedia('(pointer: fine)').matches;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!fine || reduced) return;

    stage.dataset.holoTiltBound = 'true';

    var raf = null;
    frame.addEventListener('mousemove', function (e) {
      var r = frame.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width; // 0..1
      var py = (e.clientY - r.top) / r.height; // 0..1
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var rx = (0.5 - py) * 10; // deg
        var ry = (px - 0.5) * 12; // deg
        frame.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
        // .sheen is a direct child of .pd-frame, so the vars it reads live
        // on .pd-frame itself.
        frame.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
        frame.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      });
    });
    frame.addEventListener('mouseleave', function () {
      frame.style.transform = 'rotateX(0deg) rotateY(0deg)';
    });
  }

  function init() {
    document.querySelectorAll('[data-holo-tilt]').forEach(initTilt);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
